export const DEFAULT_BOT_ID = "298595683948";

export const fontFamilyMap = {
  Arial: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
  Georgia: 'Georgia, "Times New Roman", serif',
  Verdana: "Verdana, Geneva, sans-serif",
  Inter: '"Inter", "Segoe UI", sans-serif',
};

export const headerScaleMap = {
  Small: "0.95",
  Medium: "1",
  Large: "1.08",
};
